var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import CreditsConsumptionHistoryFilters from '@/modules/admin/components/AccountManagementModal/AccountManagementeCreditsConsumptionTab/CreditsConsumptionHistoryFilters.vue';
import CreditsHistoryContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementTabs/AccountManagementCreditsConsumptionTab/CreditsHistory.container.vue';
import { beginningOfTheDay, endOfTheDay, getFirstDayOfYear, getLastDayOfYear, } from '@/shared/utils/helpers';
import { getCreditConsumptions } from '@/clients/admin';
let AccountManagementCreditsConsumptionTabContainer = class AccountManagementCreditsConsumptionTabContainer extends Vue {
    constructor() {
        super(...arguments);
        this.page = 1;
        this.totalPages = 0;
        this.consumptions = [];
        this.currentBalance = null;
        this.loading = true;
        this.groupBy = 'month';
        this.rangeDate = [
            beginningOfTheDay(getFirstDayOfYear()).toISOString(),
            endOfTheDay(getLastDayOfYear()).toISOString(),
        ];
    }
    async mounted() {
        await this.fetchConsumptions();
    }
    async fetchConsumptions() {
        this.loading = true;
        const accountId = this.$store.getters['admin/get_selected_account'];
        try {
            const filters = {
                accountId: accountId,
                page: this.page,
                groupByFormat: this.groupByFormat,
                initDate: this.rangeDate[0],
                endDate: this.rangeDate[1],
            };
            const response = await getCreditConsumptions(filters);
            this.consumptions = response.data.flatMap(payload => payload.data.map(data => data));
            const metadata = response.data[0].metadata;
            if (metadata.length) {
                this.totalPages = Math.ceil(metadata[0].total / 10);
            }
            // Saldo ao vivo (credit_xds), derivado pelo Rails — não usa o snapshot defasado.
            const firstFacet = response.data[0];
            this.currentBalance = (firstFacet && firstFacet.current_balance) || null;
        }
        catch (e) {
            console.log(e);
        }
        this.loading = false;
    }
    showDetails(payload) {
        this.$store.dispatch('admin/update_credit_consumption_detail', {
            type: payload.creditType,
            group_by: this.groupByFormat,
            period: payload.period,
        });
        this.$store.dispatch('admin/update_right_tab_of_modal', 'ConsumptionsDetail');
    }
    get exportBalanceLabel() {
        return this.currentBalance ? this.currentBalance.export : '—';
    }
    get clickBalanceLabel() {
        if (!this.currentBalance)
            return '—';
        return this.currentBalance.unlimited_click
            ? 'Ilimitado'
            : this.currentBalance.click;
    }
    // eslint-disable-next-line getter-return
    get groupByFormat() {
        if (this.groupBy === 'day')
            return '%Y-%m-%d';
        if (this.groupBy === 'month')
            return '%Y-%m';
        if (this.groupBy === 'year')
            return '%Y';
    }
    pageChange(page) {
        this.page = page;
        this.fetchConsumptions();
    }
    async changeGroupBy(value) {
        this.page = 1;
        this.groupBy = value;
        this.fetchConsumptions();
        this.$store.dispatch('admin/update_right_tab_of_modal', null);
    }
    async changeDate(values) {
        this.page = 1;
        this.rangeDate = values.map(v => v.toISOString());
        this.fetchConsumptions();
        this.$store.dispatch('admin/update_right_tab_of_modal', null);
    }
    firstDayCurrentMonth() {
        return new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    }
    lastDayCurrentMonth() {
        return new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    }
};
AccountManagementCreditsConsumptionTabContainer = __decorate([
    Component({
        components: {
            CreditsConsumptionHistoryFilters,
            CreditsHistoryContainer,
        },
    })
], AccountManagementCreditsConsumptionTabContainer);
export default AccountManagementCreditsConsumptionTabContainer;
